<template>
  <div>
    <AppHeader />

    <SnackNotification
      :snackbar="snackAlert.status"
      :boldMessage="snackAlert.boldMessage"
      :message="snackAlert.message"
      :success="snackAlert.success"
      :error="snackAlert.error"
    />

    <AppDrawer />
    <v-main>
      <slot />
    </v-main>

    <AppFooter />
  </div>
</template>

<script>
import AppHeader from "@/components/AppHeader";
import AppFooter from "@/components/AppFooter";
import AppDrawer from "@/components/AppDrawer";

import SnackNotification from "@/components/SnackNotification.vue";
const regeneratorRuntime = require("regenerator-runtime");
import { mapGetters } from "vuex";
export default {
  components: {
    AppHeader,
    AppDrawer,
    AppFooter,
    SnackNotification
  },
  computed: {
    ...mapGetters({
      snackAlert: "snackAlert"
    })
  }
};
</script>